/* global host */
/* global layer */
import utils from 'utils';
import statisticsModal from './view/statisticsModal.html'
import modalList from '../../reimburseManage/reimbursement/view/modalList.html'
class rolloutListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, sweetalert, initSortService) {
        $scope.dateConfig = {
            format: 'yyyymm',
            startView: 'year',
            minView: 'year',
            endDate: new Date()
        }
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                turnoutType: '', // 开始时间 ,
                invoiceNumber: '', // 结束时间 ,
                invoiceType: '',
                deductionPeriod: '',
                turnoutPeriod: '',
            }
        }
        $scope.reset = function reset() {
            $scope.queryParam.param = {
                turnoutType: '', // 开始时间 ,
                invoiceNumber: '', // 结束时间 ,
                invoiceType: '',
                deductionPeriod: '',
                turnoutPeriod: '',
            }
        }
        async function getRuleList(ruleType) {
            let result = []
            const res = await httpRequest.get_getIvatRuleConfList({
                ruleType
            })
            result = res.data.value
            result.forEach((ele) => {
                ele.enumName = ele.ruleName
                ele.enumCode = ele.ruleConfId
            })
            return result
        }
        getRuleList('zclx').then(res => {
            $scope.ivatRuleList = res
        })
        // $scope.reset()
        httpRequest.get_dictByTypeArr(['ivat_turnout_inv_type', 'deduction_flag']).then(res => {
            Object.assign($scope.dictData, res.data.value);
        })
        // 选中项
        $scope.selectedRows = []
        $scope.currentOvatAmt = {}
        $scope.$watch('selectedRows.length', () => {
            if (!$scope.selectedRows.length) {
                $scope.turnoutTaxamt = $scope.currentOvatAmt.turnoutTaxamt
                $scope.num = $scope.currentOvatAmt.num
                return
            }
            $scope.turnoutTaxamt = 0
            $scope.num = $scope.selectedRows.length
            $scope.selectedRows.forEach(item => {
                $scope.turnoutTaxamt += item.turnoutTaxamt
            })
        })

        function getData() {
            httpRequest.post_turnoutAccountSum($scope.queryParam).then((res) => {
                $scope.turnoutTaxamt = res.data.value.turnoutTaxamt.toFixed(2) || '0.00'
                $scope.num = res.data.value.num || 0
                $scope.currentOvatAmt = {
                    turnoutTaxamt: $scope.turnoutTaxamt,
                    num: $scope.num,
                }
            })
        }
        $scope.queryList = function queryList() {
            httpRequest.post_pageTurnoutAccount($scope.queryParam).then(res => {
                $scope.contractList = res.data.value.list;
                $scope.queryParam.total = res.data.value.total;
                $scope.queryParam.pageNum = res.data.value.pageNum;
                $scope.selectedRows = [];
            });
            getData()
        };
        $scope.searchList = function () {
            $scope.queryList();
        };
        $scope.queryList()
        // 分页
        $scope.pageChanged = function () {
            // 点击页码发起查询
            $scope.queryList();
        };

        // 初始化查询和表格控件实例
        $scope.customizedConfig = {
            version: 1.0,
            queryConfig: [{
                    label: '发票类型',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '抵扣属期',
                    selected: false,
                    default: false,
                },
                {
                    label: '转出属期',
                    selected: false,
                    default: false,
                },
                {
                    label: '转出类型',
                    selected: true,
                    default: true,
                },
            ],
            table: [{
                    label: '发票类型',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '税额',
                    selected: true,
                    default: true,
                },
                {
                    label: '抵扣属期',
                    selected: true,
                    default: true,
                },
                {
                    label: '抵扣状态',
                    selected: true,
                    default: true,
                },
                {
                    label: '转出类型',
                    selected: true,
                    default: true,
                },
                {
                    label: '转出属期',
                    selected: true,
                    default: true,
                },
                {
                    label: '转出税额',
                    selected: true,
                    default: true,
                },
                {
                    label: '转出说明',
                    selected: true,
                    default: true,
                },
            ],
        }



        $scope.tableDropdownConfig = [{
                label: '详情',
                handler(item) {
                    $uibModal.open({
                        templateUrl: 'rollout-detail.html',
                        controller: ['$scope', 'reqVal', '$uibModalInstance', 'hasPDFReader', function ($scope, reqVal, $uibModalInstance, hasPDFReader) {
                            $scope.param = reqVal.item
                            httpRequest.get_selectBillDetailById($scope.param.invoiceId).then(res => {
                                const result = res.data.value
                                if (result.fileInfo) {
                                    $scope.imgSrc = `${host.etcloudIvatApp}common/common/getFile?fileKey=${result.fileInfo.storageKey}`
                                    if (result.fileInfo.fileType == 'pdf') {
                                        $scope.ispdf = true
                                        if (hasPDFReader()) $scope.canShowPDF = true
                                    }
                                } else {
                                    $scope.noimg = true
                                    $scope.imgSrc = ''
                                }
                            })
                            $scope.param.imageKey = `${host.etcloudIvatApp}common/common/getFile?fileKey=${$scope.param.imageKey}`
                            $scope.dictData = reqVal.dictData
                            $scope.ivatRuleList = reqVal.ivatRuleList
                            $scope.cancel = function () {
                                $uibModalInstance.close()
                            }
                        }],
                        backdrop: 'static',
                        openedClass: 'mod-modal-modaldetails mod-modal mod-modal-hg',
                        resolve: {
                            reqVal() {
                                return {
                                    item,
                                    ivatRuleList: $scope.ivatRuleList,
                                    dictData: $scope.dictData
                                }
                            },
                        },
                    })
                },
                showWhile(item, hasPermit) {
                    return true;
                },
            },
            {
                label: '取消',
                handler(item) {
                    $scope.batchCancel([item])
                },
                showWhile(item, hasPermit) {
                    return hasPermit('r_cancel_rollout');
                },
            },
        ];
        $scope.rolloutStatistics = function rolloutStatistics() {
            $uibModal.open({
                template: statisticsModal,
                controller: 'statisticsModalCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-modaldetails mod-modal mod-modal-hg',
            })
        }

        $scope.batchCancel = function (list) {
            const arr = list ? list : $scope.selectedRows
            const invoiceIdList = []
            arr.forEach(item => {
                invoiceIdList.push(item.invoiceId)
            })
            sweetalert.confirm('取消提醒', '确定取消转出？').then(() => {
                httpRequest.post_batchCalTurnoutBill(invoiceIdList).then((res) => {
                    if (res.data.value.length) {
                        const params = {
                            sourceCount: invoiceIdList.length,
                            errorCount: res.data.value.length,
                            list: res.data.value,
                            title: '取消转出'
                        }
                        resultTipService.openErrorModal(params, $scope.queryList)
                    } else {
                        logger.logSuccess('取消转出成功');
                        $scope.queryList();
                    }
                });
            });

        }

        $scope.exportContract = function exportContract() {
            const reqObj = $.extend({}, $scope.queryParam.param, {
                selectedIdList: $scope.selectedRows.map(x => x.invoiceId),
            });
            let _url = `${
                host.etcloudIvatApp
            }manage/ivatBillExtend/exportTurnoutAccount?accessToken=${localStorage.getItem(
                'id_token'
            )}`;
            utils.post_downLoad(reqObj, _url);
        };

        // 表头排序
        $scope.orderMap = initSortService();
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {};
            if ($scope.orderMap.sortKey)
                $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal;
            $scope.queryList();
        };
    }
}

rolloutListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', 'sweetalert', 'initSortService'];
export default rolloutListCtrl;


// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/rollout/rolloutListCtrl.js